

import React, { useState } from 'react';
import { Typography, TextField, Button } from '@mui/material';
import CustomerLayout from './CustomerLayout'; // Assuming this is your layout component
import Customers from './Customers'; // Assuming this is your customer management component
import WithAuth from './WithAuth';

function DeleteCustomers() {
  const [onDelete, setDelete] = useState(true);
  const [uploadId, setUploadId] = useState(''); // State for upload ID input
  const [refresh, setRefresh] = useState(false);

  const handleDeleteMany = async (rows) => {
    const confirmDelete = window.confirm(`Are you sure you want to delete the selected customers?`);

    if (!confirmDelete) {
      return; // Exit if the user cancels
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/delete`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uniqueMergeIds: rows }),
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('Error deleting customers:', result);
        throw new Error(result.message || 'Failed to delete customers');
      }

      alert('Selected customers deleted successfully!');
      console.log('Deleted customers:', rows);
    } catch (error) {
      console.error('Error deleting customers:', error);
      alert(`Failed to delete customers: ${error.message}`);
    }
  };

  const handleDeleteByUploadId = async () => {
    if (!uploadId.trim()) {
      alert('Please enter a valid upload ID.');
      return;
    }

    const confirmDelete = window.confirm(`Are you sure you want to delete customers with upload ID "${uploadId}"?`);
    if (!confirmDelete) {
      return; // Exit if the user cancels
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/uploadId`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uploadId }),
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('Error deleting customers:', result);
        throw new Error(result.message || 'Failed to delete customers');
      }

      alert('Customers deleted successfully by upload ID!');
      console.log('Deleted customers for upload ID:', uploadId);
      setUploadId(''); // Clear input field after success
      setRefresh((prev) => !prev)
    } catch (error) {
      console.error('Error deleting customers:', error);
      alert(`Failed to delete customers: ${error.message}`);
    }
  };

  return (
    <>
      <CustomerLayout>
        <Typography sx={{ margin: '25px', marginTop: '90px' }}>Delete Based on Upload ID</Typography>
        <TextField
          label="Upload ID"
          variant="outlined"
          value={uploadId}
          onChange={(e) => setUploadId(e.target.value)}
          sx={{ marginBottom: '20px', marginLeft: '30px', marginRight: '20px' }}
        />
        <Button variant="contained" color="primary" onClick={handleDeleteByUploadId}>
          Delete by Upload ID
        </Button>
      </CustomerLayout>
      <Customers header={'Delete Customers'} refresh={refresh} onDelete={onDelete} setDelete={setDelete} handleDeleteMany={handleDeleteMany} />
    </>
  );
}

export default WithAuth(DeleteCustomers);
